import React from 'react';
import { Route, Routes } from 'react-router-dom';

const CustomContentTemplate = React.lazy(() =>
  import(
    '../components/pages/custom-content-template/CustomContentTemplate.jsx'
  )
);
const TemplateActivitiesLog = React.lazy(() =>
  import(
    '../components/pages/template-activities-log/TemplateActivitiesLog.jsx'
  )
);
const DoctorsActivitiesLog = React.lazy(() =>
  import('../components/pages/doctors-activities-log/DoctorsActivitiesLog.jsx')
);

function PrivateRoutes() {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route
          path="/custom-content-template"
          element={<CustomContentTemplate />}
        />
        <Route
          path="/template-activities-log"
          element={<TemplateActivitiesLog />}
        />
        <Route
          path="/doctors-activities-log"
          element={<DoctorsActivitiesLog />}
        />
        {/* Add more private routes as needed */}
      </Routes>
    </React.Suspense>
  );
}

export default PrivateRoutes;
